import { ExternalLink } from '@ui-components/actions/ExternalLink'
import { LooseFormSectionContent } from '@ui-components/containers/LooseSectionContent'
import { ListSection } from '@ui-components/global/LayoutStyling'
import { SecondaryHeading } from '@ui-components/typography/headings/SecondaryHeading'
import { BodyText } from '@ui-components/typography/Typography'
import { JSX } from 'react'
import { useIntl } from 'react-intl'

import { getEntraceStepTranslations } from '../translations'

export const ServiceInfo = (): JSX.Element => {
  const {
    serviceInfoSection: { header, texts, linkHref: href, linkText },
  } = getEntraceStepTranslations(useIntl().formatMessage)

  return (
    <LooseFormSectionContent>
      <SecondaryHeading header={header} />
      <ListSection $listStyleType="disc">
        <ul>
          {texts.map((text) => (
            <li key={text}>{text}</li>
          ))}
        </ul>
      </ListSection>
      <BodyText>
        <ExternalLink href={href}>{linkText}</ExternalLink>
      </BodyText>
    </LooseFormSectionContent>
  )
}
